module.exports = __webpack_public_path__ + "img/beian.0c57706.png";